import { gql } from '@apollo/client';

// todo: if 6~106 lines are useful, please move it and made loading component data partially;if it is useless ,please delete it
export const PROJECT_PAGE_QUERY = gql`
  query ($id: Int) {
    posts(request: { page: 1, perPage: 13 }) {
      items {
        id
        propertyType
        title
        views
        date
        modified
        link
        excerpt
        author {
          id
          name
          nickname
          description
          link
          profileImage {
            url
            title
            width
            height
          }
          total_post
        }
        categories {
          id
          name
          link
        }
        tags {
          id
          name
          link
        }
        postCategory
        videoType
        featuredImage {
          url
          title
          width
          height
        }
        heroImage {
          url
          title
          width
          height
        }
        totalComments
      }
    }
    project(request: { id: $id }) {
      id
      title
      title2
      title3
      propertyType
      date
      modified
      link
      status
      author {
        id
        name
        nickname
        description
        link
        profileImage {
          url
          title
          width
          height
        }
        total_post
      }
      propertyType
      featuredImage {
        url
        width
        height
        title
      }
      heroImage {
        url
        width
        height
        title
      }
      totalComments
      tags {
        id
        name
        link
        slug
      }
      developer {
        name
        website
        website_label
        phone
      }
      location {
        zone {
          value
          label
          link
          parent {
            value
            label
            link
          }
        }
        district {
          value
          label
          link
          parent {
            value
            label
            link
          }
        }
        road {
          value
          label
          link
          parent {
            value
            label
            link
          }
        }
        coordinate {
          longitude
          latitude
        }
      }
      facilities {
        label
        value
      }
      securities {
        value
        label
      }
      roomTypes {
        name
        status
        min_size
        max_size
      }
      buildingProfile {
        value
        label
      }
      transportations {
        value
        label
        link
      }
      statusAvailability {
        value
        label
      }
      statusDevelopment {
        value
        label
      }
      completionDate
      startDate
      priceTypes {
        starting_price
        display_price
        per_square_meter
        maintenance_fee
        signing_fee
        fund
        level {
          value
          label
        }
      }
      roomProfile {
        ceiling_height
        equipment {
          value
          label
        }
        sink {
          value
          label
        }
        stove_hood {
          value
          label
        }
      }
      units {
        image {
          url
          title
          width
          height
        }
        unit_name
        price {
          min
          max
        }
        building_size
        specifications {
          bedrooms
          bathrooms
          garage
        }
        building_type {
          label
          value
        }
      }
      leadCaptureFormId
      leadCaptureFormStartDate
      leadCaptureFormEndDate
    }
  }
`;
